import orderApprove from './orderApprove'
import agOrderApprove from './agOrderApprove'

export default [
  {
    path: '/null',
    component: () => import('@/components'),
    children: [
      ...orderApprove,
      ...agOrderApprove
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/approveManage/index.js